module.exports = __webpack_public_path__ + "static/media/hero_header.748104df.jpg";